webpackJsonp([31],{

/***/ "Om7N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var underscore_extensions_1 = __webpack_require__("R0iF");
var SignUpBlock = (function () {
    SignUpBlock.$inject = ["$state"];
    function SignUpBlock($state) {
        this.$state = $state;
    }
    SignUpBlock.prototype.openSignUp = function () {
        var state = underscore_extensions_1.Utils.getProduct().toLowerCase();
        this.$state.go(state + "-signup", { email: this.email, sendRequest: true });
    };
    return SignUpBlock;
}());
angular.module('animatronApp.signUpBlock', []).component('signUpBlock', {
    controller: SignUpBlock,
    templateUrl: __webpack_require__("m5k6")
});


/***/ }),

/***/ "m5k6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/sign-up-block_cb1be651ec84fe0eb6a2999b580d66d2.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/31-82c0e6a2dceb23823569.min.js